import deviceService from '@/api/device'
import { DEVICE } from '../types'

export default {
  namespaced: true,
  state: {
    devicesStatus: [],
    dashboards: [
      {
        sensors: []
      }
    ]
  },
  getters: {
    deviceOffline (state, getters) {
      return getters.totalDevices - getters.deviceOnline
    },
    deviceOnline (state) {
      let online = 0
      state.devicesStatus.forEach(room => {
        online = online + room.thingsInfo.filter(device => device.isOnline).length
      })
      return online
    },
    totalDevices (state) {
      let online = 0
      state.devicesStatus.forEach(room => {
        online = online + room.thingsInfo.length
      })
      return online
    }
  },
  mutations: {
    [DEVICE.SET_DEVICE_STATUS] (state, devicesStatus) {
      state.devicesStatus = devicesStatus
    },
    [DEVICE.SET_DASHBOARDS] (state, dashboards) {
      state.dashboards = dashboards
    }
  },
  actions: {
    getDevicesStatusList ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve) => {
        deviceService.getDevicesStatus().then((response) => {
          commit(DEVICE.SET_DEVICE_STATUS, response.data)
          resolve()
        }).finally(()=>{
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    getDashboards({commit, dispatch}) {
      return new Promise((resolve) => {
        deviceService.getDashboards().then((response) => {
          commit(DEVICE.SET_DASHBOARDS, response.data)
          resolve()
        })
      }).finally(() => {
        dispatch('Global/hideLoading', null, {root: true})
      })
    },
    saveSensors: function ({dispatch, state}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        deviceService.saveSensors(payload, state.dashboards[0].id).then(() => {
          dispatch('getDashboards')
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    removeSensor: function ({dispatch, state}, id) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        deviceService.removeSensor(id, state.dashboards[0].id).then(() => {
          dispatch('getDashboards')
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    }
  }
}
